import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';

import { Routing } from './app.routes';

import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { LayoutComponent } from './layout/layout.component';
import { LoginComponent } from './login/login.component';
import { SpaceComponent } from './space/space.component';
import { SpaceStep1Component } from './space-step-1/space-step-1.component';
import { SpaceStep2Component } from './space-step-2/space-step-2.component';
import { SpaceStep3Component } from './space-step-3/space-step-3.component';
import { SpaceStep4Component } from './space-step-4/space-step-4.component';
import { SpaceStep5Component } from './space-step-5/space-step-5.component';
import { SpaceStep6Component } from './space-step-6/space-step-6.component';
import { SpaceStep7Component } from './space-step-7/space-step-7.component';
import { SpaceStep8Component } from './space-step-8/space-step-8.component';
import { SpaceStep9Component } from './space-step-9/space-step-9.component';

import { AuthGuard } from './guards/auth.guard';
import { RedirectGuard } from './guards/redirect.guard';

import { ApiService } from './services/api.service';
import { LocalStorageService } from './services/localstorage.service';

import { VQFormsModule } from './vqforms/vqforms.module';
import { VQUtilsModule } from './vqutils/vqutils.module';
import { ContactComponent } from './contact/contact.component';
import { NotifComponent } from './notif/notif.component';
import { PostComponent } from './post/post.component';
import { AdminsComponent } from './admins/admins.component';


@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    LayoutComponent,
    LoginComponent,
    SpaceComponent,
    SpaceStep1Component,
    SpaceStep2Component,
    SpaceStep3Component,
    SpaceStep4Component,
    SpaceStep5Component,
    SpaceStep6Component,
    SpaceStep7Component,
    SpaceStep8Component,
    SpaceStep9Component,
    ContactComponent,
    NotifComponent,
    PostComponent,
    AdminsComponent
  ],
  imports: [
    BrowserModule,
    Routing,
    FormsModule,
    HttpModule,
    VQFormsModule,
    VQUtilsModule,
  ],
  providers: [
    AuthGuard,
    RedirectGuard,
    ApiService,
    LocalStorageService,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts